var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.9 0 4 0.9 4 2V30C4 31.1 4.9 32 6 32H26C27.1 32 28 31.1 28 30V8L20 0H6Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H28L20 0V6C20 7.1 20.9 8 22 8Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L22 8H28V14Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26C24 26.55 23.55 27 23 27H1C0.45 27 0 26.55 0 26V16C0 15.45 0.45 15 1 15H23C23.55 15 24 15.45 24 16V26Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 18.947C4.35938 18.683 4.56737 18.395 4.90237 18.395H6.74937C7.78937 18.395 8.72538 19.091 8.72538 20.425C8.72538 21.689 7.78937 22.393 6.74937 22.393H5.41437V23.449C5.41437 23.801 5.19037 24 4.90237 24C4.63837 24 4.35938 23.801 4.35938 23.449V18.947ZM5.41437 19.402V21.394H6.74937C7.28537 21.394 7.70937 20.921 7.70937 20.425C7.70937 19.866 7.28537 19.402 6.74937 19.402H5.41437ZM10.2914 24C10.0274 24 9.73938 23.856 9.73938 23.505V18.963C9.73938 18.676 10.0274 18.467 10.2914 18.467H12.1224C15.7764 18.467 15.6964 24 12.1944 24H10.2914ZM10.7954 19.443V23.025H12.1224C14.2814 23.025 14.3774 19.443 12.1224 19.443H10.7954ZM16.9924 19.507V20.778H19.0314C19.3194 20.778 19.6074 21.066 19.6074 21.345C19.6074 21.609 19.3194 21.825 19.0314 21.825H16.9924V23.504C16.9924 23.784 16.7934 23.999 16.5134 23.999C16.1614 23.999 15.9464 23.784 15.9464 23.504V18.962C15.9464 18.675 16.1624 18.466 16.5134 18.466H19.3204C19.6724 18.466 19.8804 18.675 19.8804 18.962C19.8804 19.218 19.6724 19.506 19.3204 19.506H16.9924V19.507Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H4V28H23C23.55 28 24 27.55 24 27V26C24 26.55 23.55 27 23 27Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.c2dc5fae9f741c776f80e75d0a9740bd.svg";
export { ForwardRef as ReactComponent };